exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-list-invites-facet-hive-component[data-v-867fd5e6] {\n  width: 100%;\n  margin-top: 30px;\n}\n", ""]);

// exports
